export const ru = {
    action_paid: 'Оплачено',
    info: 'Перевести в статус “Оплачено“',
    title: 'Оплатить транзакцию?',
};
